/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { Icon } from '@salesforce/design-system-react';
import PropTypes from 'prop-types';
import React from 'react';

import RecentlyRunAutomation from './item';
import { ProvisionedCard } from '../../homepage-card';
import CardFooter from '../../card-footer';
import UnprovisionedAutomationStudio from '../unprovisioned/unprovisioned-automation-studio';

const journeyBuilderIcon = (
  <Icon category="custom" name="custom106" size="small" style={{ backgroundColor: '#b17fd1' }} />
);

function handleDeepLink(onDeepLink, automation) {
  if (onDeepLink) {
    let link;

    if (automation && automation.id) {
      link = `/AutomationStudioFuel3/#Instance/${automation.id}`;
    }

    onDeepLink({
      appName: 'Automation Studio',
      analyticsName: 'Recently Run Automations',
      link,
    });
  }
}

function localizeStatus(localizations, status) {
  let value;

  switch (status && status.toLowerCase()) {
    case 'ready':
    case 'pausedschedule':
    case 'stopped':
    case 'inactivetrigger':
      value = localizations['homepage.cards.status.automation.paused'];
      break;
    case 'error':
      value = localizations['homepage.cards.status.automation.error'];
      break;
    default:
      value = localizations['homepage.cards.status.automation.running'];
      break;
  }

  return value;
}

function RecentlyRunAutomationsCard({ className, runAutomations, localizations, onDeepLink, unprovisioned }) {
  return (
    <div>
      {unprovisioned ? (
        <UnprovisionedAutomationStudio
          className={className}
          heading={localizations['homepage.cards.recently_run_automations.heading']}
          icon={journeyBuilderIcon}
          localizations={localizations}
        />
      ) : (
        <ProvisionedCard
          className={className}
          heading={localizations['homepage.cards.recently_run_automations.heading']}
          icon={journeyBuilderIcon}
          forceShowFooter
          footer={<CardFooter onClick={() => handleDeepLink(onDeepLink)} />}
        >
          {runAutomations && runAutomations.length > 0 ? (
            <ul className="slds-has-dividers--bottom-space">
              {runAutomations.map((automation) => (
                <RecentlyRunAutomation
                  {...automation}
                  lastRunStatus={localizeStatus(localizations, automation.lastRunStatus)}
                  key={automation.key}
                  localizations={localizations}
                  onClick={() => handleDeepLink(onDeepLink, automation)}
                />
              ))}
            </ul>
          ) : (
            <div className="slds-text-align--center slds-text-heading--medium" style={{ marginTop: '104px' }}>
              {localizations['homepage.cards.recently_run_automations.no_recent']}
            </div>
          )}
        </ProvisionedCard>
      )}
    </div>
  );
}

RecentlyRunAutomationsCard.displayName = 'Recently Run Automations Card';

RecentlyRunAutomationsCard.propTypes = {
  className: PropTypes.string,
  runAutomations: PropTypes.array,
  localizations: PropTypes.object,
  onDeepLink: PropTypes.func,
  unprovisioned: PropTypes.bool,
};

export default RecentlyRunAutomationsCard;
